import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';

let cachedCredentials = null;
let cachedExpiration = 0;
let cachedProvider = null;
let cachedIdToken = null;

const EXPIRY_BUFFER_MS = 5 * 60 * 1000; // refresh 5 min before expiry

export async function getSignedRequest(idToken, region, identityPoolId, userPoolId) {
  if (!idToken) throw new Error('Missing idToken');

  const now = Date.now();

  // Return cached credentials if still valid and token hasn't changed
  if (cachedCredentials && cachedIdToken === idToken && cachedExpiration - now > EXPIRY_BUFFER_MS) {
    return cachedCredentials;
  }

  // Rebuild provider if token changed or first call
  if (!cachedProvider || cachedIdToken !== idToken) {
    cachedProvider = fromCognitoIdentityPool({
      client: new CognitoIdentityClient({ region }),
      identityPoolId,
      logins: {
        [`cognito-idp.${region}.amazonaws.com/${userPoolId}`]: idToken,
      },
    });
    cachedIdToken = idToken;
  }

  const creds = await cachedProvider();

  cachedCredentials = {
    accessKeyId: creds.accessKeyId,
    secretAccessKey: creds.secretAccessKey,
    sessionToken: creds.sessionToken,
  };

  // Use expiration from Cognito if available, otherwise default to 1 hour
  cachedExpiration = creds.expiration ? new Date(creds.expiration).getTime() : now + 60 * 60 * 1000;

  return cachedCredentials;
}
